import React from "react";
import { HeaderContainer, LogoContainer, NavContainer } from "./styled";
import WizzBeeHeaderPhoneSrc from "../../assets/images/header/phone-alt.svg";
import logo from "../../assets/images/logo-gc.svg";
import { useNavigate } from "react-router";
import { StyledContainer } from "../Layout/styled";

const Header = () => {
  const navigate = useNavigate();
  const redirectTo = (path) => {
    navigate(path);
  };
  return (
    <HeaderContainer>
      <StyledContainer
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <LogoContainer
          src={logo}
          alt="logo Granny & Charly"
          onClick={() => redirectTo("/")}
        />
        <div
          style={{
            display: "flex",
            flex: "none",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "230px",
              height: "45px",
              backgroundColor: "#ED6C76",
              gap: "0.5rem",
              lineHeight: "22.5px",
            }}
          >
            <img
              src={WizzBeeHeaderPhoneSrc}
              alt="illustration des personnages granny et charly"
              style={{ marginLeft: "10px" }}
            />
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: "700",
                fontSize: "24px",
                color: "white",
              }}
            >
              09 78 45 01 71
            </p>
          </div>
        </div>
      </StyledContainer>
    </HeaderContainer>
  );
};

export default Header;
